import getFieldDisplayValue, { getSortDisplayValue } from './getFieldDisplayValue'

// 合并查询字段
const mergeQueryFieldsValue = ({ form, values, fieldsGroup }: any) => {
    return fieldsGroup
        .map(v => {
            return {
                groupKey: v.groupKey,
                groupTitle: v.groupTitle,
                groupAfterBorder: v.groupAfterBorder,
                fields: v.fields
                    .map(v1 => {
                        const displayValue = getFieldDisplayValue({
                            field: v1,
                            value: values?.[v1.name],
                            localData: form?.getLocalData?.(v1.name)
                        })

                        return {
                            ...v1,
                            value: values?.[v1.name],
                            displayValue
                        }
                    })
                    .filter(v1 => v1.displayValue)
            }
        })
        .filter(v => v.fields?.length)
}

// 合并排序字段
const mergeSortValue = ({ sortFields, sortValues }: any) => {
    if (sortFields && sortValues) {
        const sortField = sortFields.find(v => v.name === sortValues.name)
        const sortOption = sortField?.options?.find(v => v.value === sortValues.value)

        return {
            name: sortValues.name,
            value: sortOption ? sortValues.value : undefined,
            displayValue: getSortDisplayValue({ fields: sortFields, value: sortValues })
        }
    }

    return null
}

export default ({ form, fieldsGroup, values, sortFields, sortValues }: any) => {
    const newQueryFields = mergeQueryFieldsValue({ form, fieldsGroup, values })
    const newSortValues = mergeSortValue({ sortFields, sortValues })

    return {
        queryFields: newQueryFields,
        sortValues: newSortValues
    }
}
